import { ContentSource } from "../types";

export const canBeTested = (contentSource: ContentSource): boolean => {
  const testedLabels = contentSource.labels.filter(l => !l.nonTested);

  if (testedLabels.length === 0) {
    return false;
  }

  return true;
};
